import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";


const faqData = [
  {
    question: "Do I need a sponsor in the UAE to get a visa?",
    answer: "No, you do not need a sponsor to apply for a tourist visa through us. We act as your sponsor and handle all the formalities."
  },
  {
    question: "What are the photo requirements for a Dubai visa?",
    answer: "You'll need a recent passport-size photograph with a white background. The photo should be clear, in color, and show your full face."
  },
  {
    question: "Can I get a visa on arrival in Dubai?",
    answer: "Visa on arrival is available for citizens of certain countries. However, it's always recommended to check the latest regulations and apply for a visa in advance to avoid any issues."
  },
  {
    question: "How can I check the status of my visa application?",
    answer: "You can use the 'Tracker' tab in our visa calculator section on the homepage. Just enter your application ID to see the live status."
  },
  {
    question: "Is it possible to extend my tourist visa in Dubai?",
    answer: "Yes, it is possible to extend your visa. We offer inside country visa extension services. Please contact us for more details on the process."
  },
];

export function DubaiVisaFaqs() {
  return (
    <div className="w-full">
        <div className="mb-8">
            <h2 className="text-2xl font-bold">Dubai Visa FAQs</h2>
        </div>
        <Accordion type="single" collapsible className="w-full space-y-3">
        {faqData.map((item, index) => (
            <AccordionItem value={`item-${index}`} key={index} className="bg-gray-50 px-4 rounded-lg border-gray-200">
              <AccordionTrigger className="text-left font-semibold text-neutral-700 hover:no-underline">{item.question}</AccordionTrigger>
              <AccordionContent className="text-neutral-600">
                  {item.answer}
              </AccordionContent>
            </AccordionItem>
        ))}
        </Accordion>
    </div>
  );
}
